import { IPopUpData, IPopUpInfo, IPopupSettings, PopupLayoutType } from "@pageBuilder/typings";
import { RendererBase } from "src/shared/renderer-base";
import { Base64Util } from "src/utils/base64-util";
import { ElementUtil } from "src/utils/element-util";

export class PopUpRenderer extends RendererBase<IPopUpData> {

    protected override createNewInternal(): HTMLElement {
        const wrapper = document.createElement("div");
        wrapper.classList.add("page-popup-wrapper", "page-popup-wrapper-position");
        wrapper.setAttribute("state", "disable");

        const overlay = document.createElement("div");
        overlay.classList.add("popup-overlay");

        const popupSectionWrapper = document.createElement("div");
        popupSectionWrapper.classList.add("popup-section-wrapper");

        wrapper.append(overlay, popupSectionWrapper);
        return wrapper;
    }

    protected override renderInternal(element: HTMLElement, data: IPopUpData): HTMLElement {
        if (!data.popupSection) {
            return element;
        }

        this.renderLayout(element, data.popupSection.layout);

        if (data.popupSection.sectionVisibility) {
            ElementUtil.setVisibilityClasses(element, data.popupSection.sectionVisibility);
        }

        this.setPopupSettingsData(element, data.popupSection.popupSettings);

        if (this.isPublishRendering || this.isPrerendering) {
            this.setPopupInfoData(element, data.popupInfo);
        }

        return element;
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override cleanupInternal(element: HTMLElement): void {
        // nothing
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override getContentSelectorsInternal(element: HTMLElement): string[] {
        return [];
    }

    private renderLayout(element: HTMLElement, type: PopupLayoutType): void {
        const sectionWrapperElement = this.getSectionWrapperElement(element);
        sectionWrapperElement.classList.remove("layout-center", "layout-bottom-left",
            "layout-bottom-right", "layout-top-left", "layout-top-right", "layout-full-screen",
            "layout-right-sidebar", "layout-left-sidebar", "layout-bottom-sidebar","layout-top-sidebar");

        let layoutClass = "layout-center";

        switch (type) {
            case "Center": layoutClass = "layout-center"; break;
            case "BottomLeft": layoutClass = "layout-bottom-left"; break;
            case "BottomRight": layoutClass = "layout-bottom-right"; break;
            case "TopLeft": layoutClass = "layout-top-left"; break;
            case "TopRight": layoutClass = "layout-top-right"; break;
            case "FullScreen": layoutClass = "layout-full-screen"; break;
            case "RightSidebar": layoutClass = "layout-right-sidebar"; break;
            case "LeftSidebar": layoutClass = "layout-left-sidebar"; break;
            case "BottomSidebar": layoutClass = "layout-bottom-sidebar"; break;
            case "TopSidebar": layoutClass = "layout-top-sidebar"; break;
        }

        sectionWrapperElement.classList.add(layoutClass);
    }

    private getSectionWrapperElement(element: HTMLElement): HTMLElement {
        return element.querySelector(".popup-section-wrapper") as HTMLElement;
    }

    private setPopupSettingsData(element: HTMLElement, data?: IPopupSettings | null): void {
        const json = Base64Util.serialize(data) ?? "";
        element.setAttribute("data-popup", json);
    }

    private setPopupInfoData(element: HTMLElement, data?: IPopUpInfo): void {
        const json = Base64Util.serialize(data) ?? "";
        element.setAttribute("info", json);
    }

}
